var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('van-pull-refresh',{staticClass:"pull-refresh",on:{"refresh":_vm.onRefresh},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }